export enum SegmentNextPage {
  ResultPage = "ResultPage",
  NextSegment = "NextSegment",
  PurchaseModels = "PurchaseModels",
}
